import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient from "../../../../api/admin";

type UseResetPasswordMutationOptions = {
  onSuccess?: (data: { link: string }) => void;
  onError?: (error: Error) => void;
};

const useResetPasswordMutation = (
  options?: UseResetPasswordMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => adminApiClient.resetPassword(userId),
    onSuccess: (data) => {
      // Invalidate any user-related queries if needed
      queryClient.invalidateQueries({ queryKey: ["users"] });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      console.error("Generate reset link error:", error);
      options?.onError?.(error);
    },
  });
};

export default useResetPasswordMutation;
